import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Chip } from '@frontend/design-system';
import { useCareCreditTranslations } from '../hooks/use-care-credit-translations';
import { CareCreditPatientStatus } from '../types/care-credit.types';

const styles = {
  chip: css`
    height: 18px;
    .chip-text {
      display: flex;
      align-items: center;
      flex-direction: row;
      gap: ${theme.spacing(0.5)};
      & > .icon {
        width: 10px;
        flex-shrink: 0;
      }
    }
  `,
};

export type CareCreditChipProps = {
  status?: CareCreditPatientStatus;
};
export const CareCreditChip = ({ status }: CareCreditChipProps) => {
  const { t } = useCareCreditTranslations();

  if (status === 'approved') {
    return (
      <Chip variant='success' css={styles.chip}>
        <span className='icon'>
          <Icon name='check' size={10} />
        </span>
        <span>{t('Cardholder')}</span>
      </Chip>
    );
  } else if (status === 'pre-approved') {
    return (
      <Chip variant='seaweed' css={styles.chip}>
        <span className='icon'>
          <Icon name='credit-card' size={10} />
        </span>
        <span>{t('Preapproved')}</span>
      </Chip>
    );
  } else if (status === 'not-enrolled') {
    return (
      <Chip variant='warn' css={styles.chip}>
        <span className='icon'>
          <Icon name='warning-badge' size={10} />
        </span>
        <span>{t('Prequalification check')}</span>
      </Chip>
    );
  } else if (status === 'declined') {
    return (
      <Chip variant='critical' css={styles.chip}>
        <span className='icon'>
          <Icon name='x' size={10} />
        </span>
        <span>{t('Declined')}</span>
      </Chip>
    );
  } else if (status === 'unknown-or-error') {
    return null;
    // return (
    //   <Chip variant='critical' css={styles.chip}>
    //     <span className='icon'>
    //       <Icon name='error-badge' size={10} />
    //     </span>
    //     <span>{t('Unable to determine status')}</span>
    //   </Chip>
    // );
  }

  return null;
};

export const CareCreditErrorChip = ({ message, isLoading }: { message: string | undefined; isLoading: boolean }) => {
  return (
    <Chip variant={isLoading ? 'default' : 'critical'} css={styles.chip}>
      <span className='icon'>
        <Icon name={isLoading ? 'pending' : 'error-badge'} size={10} />
      </span>
      <span>{message}</span>
    </Chip>
  );
};
